module.exports = __webpack_public_path__ + "img/tips_carrousel.9bb25d1f.png";